var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"auth"},[_c('login'),_c('span',{staticClass:"title",staticStyle:{"width":"50px","padding-bottom":"25px"}},[_vm._v(" - or - ")]),_c('create-account')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }